import { Box, ButtonBase, Container, styled, Typography } from '@mui/material';
import React from 'react'
import { Component } from 'react'
import { Redirect } from 'react-router-dom';
import fondo5 from '../Inicio/fondo5.jpg';

const imagesAdmin = [
    {
        url: fondo5,
        titulo: 'Alta de Usuario',
        width: '25%',
        key: 'registro'
    },
    {
        url: fondo5,
        titulo: 'Cambiar Contraseña',
        width: '25%',
        key: 'contrasenia'
    },
]

const ImageButton = styled(ButtonBase)(({ theme }) => ({
    position: 'relative',
    height: 200,
    [theme.breakpoints.down('sm')]: {
      width: '100% !important', // Overrides inline-style
      height: 100,
    },
    '&:hover, &.Mui-focusVisible': {
      zIndex: 1,
      '& .MuiImageBackdrop-root': {
        opacity: 0.15,
      },
      '& .MuiImageMarked-root': {
        opacity: 0,
      },
      '& .MuiTypography-root': {
        border: '4px solid currentColor',
      },
    },
  }));

  const ImageSrc = styled('span')({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
  });

  const Image = styled('span')(({ theme }) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
  }));
  
  const ImageBackdrop = styled('span')(({ theme }) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity'),
  }));
  
  const ImageMarked = styled('span')(({ theme }) => ({
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  }));


class GestionUsuarios extends Component {
    constructor(props){
        super(props);
        this.state = {
            registro: false,
            cambioContrasenia: false,
        }

        this.manejarClick = this.manejarClick.bind(this);
    }
    render(){
        return (
            <>
                <Container>
                {sessionStorage.login && sessionStorage.tipoUsuario === '1'
                ?
                    <Box sx={{ height: '85vh', width: '100%', display: 'flex', flexWrap: 'wrap', minWidth: 300, width: '100%' }}>
                                
                        {imagesAdmin.map((imagen) => (
                            <ImageButton focusRipple key={imagen.key} style={{width: imagen.width, marginTop: '1.5rem', marginLeft: '1rem'}}>
                                <ImageSrc  style={{ backgroundImage: `url(${fondo5})` }}/>
                                <ImageBackdrop className="MuiImageBackdrop-root" />
                                <Image onClick={() => this.manejarClick(imagen)}>
                                    <Typography component="span"
                                        variant="subtitle1"
                                        color="inherit"
                                        sx={{
                                            position: 'relative',
                                            p: 4,
                                            pt: 2,
                                            pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
                                        }}
                                    >
                                        {imagen.titulo}
                                        <ImageMarked className="MuiImageMarked-root" />
                                    </Typography>
                                </Image>
                            </ImageButton>
                        ))}
                    </Box>
                :
                    <Redirect to='/inicio'/>
                }
                </Container>
                {this.state.registro
                ?
                    <Redirect to='/registro'/>
                :
                    this.state.cambioContrasenia
                    ?
                        <Redirect to='/cambio'/>
                    :
                        null
                }
            </>
        )//Final return
    }//Final render

    manejarClick(imagen){
        if(imagen.key === 'registro'){
            this.setState({
                registro: true,
                cambioContrasenia: false,
            })
        }else if(imagen.key === 'contrasenia'){
            this.setState({
                registro: false,
                cambioContrasenia: true,
            })
        }
    }
}

export default GestionUsuarios